import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { LabraToolTipV2 } from '@labrav/react-components'
import awsImage from '../../common/images/awsCloud.png'
import gcpImage from '../../common/images/gcpMarketPlace.png'
import azureImage from '../../common/images/azureCloud.png'
import { SEO_CLOUD_MARKETPLACE, seoCloudSelectorOptions } from './seoCloud'
import { useStyles } from './SeoCloudSelector.styles'

const cloudLogo: Record<string, string> = {
  AWS: awsImage,
  GCP: gcpImage,
  AZURE: azureImage,
}

/** AWS-only selector; non-AWS options show a Coming soon tooltip (like SEO modals). */
export const SeoCloudSelector = () => {
  const { classes } = useStyles()

  const handleChange = (event: SelectChangeEvent) => {
    if (event.target.value !== SEO_CLOUD_MARKETPLACE) {
      return
    }
  }

  return (
    <FormControl variant="outlined" size="small" className={classes.root}>
      <InputLabel
        data-testid="select-label-cloud-provider"
        id="seo-select-label-cloud-provider"
        variant="outlined"
      >
        Cloud
      </InputLabel>
      <Select
        labelId="seo-select-label-cloud-provider"
        value={SEO_CLOUD_MARKETPLACE}
        label="Cloud"
        onChange={handleChange}
        inputProps={{ 'data-testid': 'cloud-provider' }}
      >
        {seoCloudSelectorOptions.map(cloud => {
          const content = (
            <div className={classes.menuItemContent}>
              <img
                src={cloudLogo[cloud.name]}
                alt={`${cloud.name}-logo`}
                className={classes.logo}
              />
            </div>
          )

          if (cloud.disabled) {
            return (
              <MenuItem
                key={cloud.name}
                value={cloud.name}
                disabled
                data-testid="menu-item"
                role="listitem"
                className={classes.disabledMenuItem}
              >
                <LabraToolTipV2
                  tooltipPlacement="bottom"
                  description="Coming soon"
                  tooltipPlacmentGap="0px"
                >
                  <span className={classes.tooltipTarget}>{content}</span>
                </LabraToolTipV2>
              </MenuItem>
            )
          }

          return (
            <MenuItem
              key={cloud.name}
              value={cloud.name}
              data-testid="menu-item"
              role="listitem"
            >
              {content}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}
